import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiRouteConfig} from '../../../config/api.route.config';
import {Injectable} from '@angular/core';
import {Inspection} from '../model/inspection';
import {Observable} from 'rxjs';
import {PaginationResponse} from '../model/pagination-response';
import {IdAndLabel} from '../model/id-and-label';
import {map, shareReplay} from 'rxjs/operators';
import {InspectionFlowStatus, InspectionSubject, InspectionType, SortDirection} from '../../common/enums/enums';
import { Multimedium } from '@npm.chapps.com/chapps.common.angular.library/lib/components/multimedium/model/multimedium';

@Injectable()
export class InspectionsService {
  
  constructor(private http: HttpClient, private config: ApiRouteConfig) {
  }

  public addInspection(inspection: Inspection): Observable<Inspection> {
    return this.http.post<Inspection>(this.config.INSPECTIONS, inspection);
  }
  
  public getAvailableInspectionTypes(subject = InspectionSubject.BUILDING): Observable<InspectionType[]> {
    const endpoint = this.config.getRouteWithInjectedParams(
        this.config.INSPECTION_TYPES, [subject]
    );
    return this.http.get<InspectionType[]>(endpoint).pipe(shareReplay(1));
  }

  public find(query: InspectionsQuery, page: number, size: number) {
    const params = new HttpParams({fromObject: query});
    return this.getInspections(params, page, size);
  }

  public getInspections(httpParams: HttpParams, pageNumber: number, pageSize: number): Observable<PaginationResponse<Inspection>> {
    const params = httpParams
      .append('pageNumber', pageNumber.toString())
      .append('pageSize', pageSize.toString());
    return this.http.get<PaginationResponse<Inspection>>(this.config.INSPECTIONS, {params: params});
  }

  public getInspectionExecutors(buildingId: string = null, inspectionType: InspectionType = null): Observable<IdAndLabel[]> {
    let params = new HttpParams();

    if(buildingId)
      params = params.append('buildingStructureId', buildingId.toString());

    if(inspectionType)
      params = params.append('inspectionType', inspectionType.toString());

    return this.http.get<any[]>(this.config.INSPECTION_EXECUTORS, {params: params}).pipe(
      map(executors => executors.map(e => new IdAndLabel(e.id, e.name)))
    );
  }

  public getInspectionLogs(inspectionId: string): Observable<any> {
    return this.http.get(
      this.config.getRouteWithInjectedParams(this.config.INSPECTION_LOGS, [inspectionId])
    );
  }

  public getInspection(inspectionId: number): Observable<any>{
    return this.http.get(
      this.config.getRouteWithInjectedParams(this.config.INSPECTION_DETAIL, [inspectionId.toString()])
    );
  }

  public getInspectionMultimedia(inspectionId: number): Observable<Multimedium[]>{
    return this.http.get<Multimedium[]>(this.config.getRouteWithInjectedParams(this.config.INSPECTION_MULTIMEDIA, [inspectionId.toString()]))
  }

}

export class InspectionsQuery {
  [index: string]: any;

  rootStructureIds?: number[] = [];
  flowStatuses?: InspectionFlowStatus[] = [];
  types?: InspectionType[] = [];
  executorsLoginIds?: number[] = [];
  inspectionIds?: number[] = [];
  scheduledOnFrom?: Date;
  scheduledOnTo?: Date;
  sortBy = InspectionsSort.ExecutedOnSheduldedOn;
  sortDirection = SortDirection.DESC;

  public static from(partial: Partial<InspectionsQuery>): InspectionsQuery {
    return Object.assign(new InspectionsQuery(), partial);
  }

}

export enum InspectionsSort {
  ExecutedOnSheduldedOn = 'ExecutedOnSheduldedOn',
}